import React, { InputHTMLAttributes } from 'react';
import clsx from 'clsx';

import styles from './Textarea.module.scss';
import { TextareaAutosize } from '@mui/material';

type TextareaProps = InputHTMLAttributes<HTMLTextAreaElement> & {
  minRows?: number;
  small?: boolean;
};

const Textarea = ({
  small,
  ...props
}: React.PropsWithChildren<TextareaProps>) => (
  <TextareaAutosize
    {...props}
    className={clsx(styles.Textarea, small && styles.small)}
  />
);

export default Textarea;
